'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UrlService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = require('../core/utils');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _array = require('core-js/fn/array');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var wrc = window.winresCloud;

var UrlService = exports.UrlService = function () {
    function UrlService($rootScope, $location, winresCloudService, $q, $timeout) {
        _classCallCheck(this, UrlService);

        this.$rootScope = $rootScope;
        this.$location = $location;
        this.winresCloudService = winresCloudService;
        this.$q = $q;

        // <winres-departure> / <winres-destination> fixed kohdesivu.
        this.isFixedKohdeSivu = false;

        // True if we want to simply put the parameters in the query string instead.
        this.useQueryString = !!(wrc && wrc.useQueryString);

        this.$timeout = $timeout;

        this.urlReaders = [];
    }

    _createClass(UrlService, [{
        key: 'checkUrl',
        value: function checkUrl() {
            if (this.isKohdeSivu()) {
                this.tryRedirect();
            }
        }
    }, {
        key: 'tryRedirect',
        value: function tryRedirect() {
            var _this = this;

            if (this.isKohdeSivu()) {
                var params = this.readUrlParams(true);

                // Url has destination code = valid
                if (params.dc) {
                    var hasBeginDate = params.bd !== undefined && params.bd.length > 0 && params.bd.length !== 1;

                    var beginDateIsInPast = (0, _moment2.default)(params.bd, 'YYYY-MM-DD') < (0, _moment2.default)().startOf('day');

                    var invalidBeginDate = !hasBeginDate || beginDateIsInPast;

                    // Redirect to next reservable period if beginDate is undefined or is in past.
                    if (invalidBeginDate) {
                        this.getNextReservablePeriod(params.dc, params.d).then(function (period) {
                            if (period !== null) {
                                // Set productCode, beginDate, endDate, numAdults, numChildren and numInfants to url.
                                params.bd = period.BeginDate;
                                params.ed = period.EndDate;
                                _this.setParamsToUrl(params, true);
                            } else {
                                console.error('[urlService] Next reservable period for ', params.dc, ' was not found!');
                            }
                        });
                    }
                } else {// Invalid
                    // console.error('[urlService] Invalid url. Redirecting to 404.');

                    // Redirect to 404
                    // window.location.href = window.location.origin + '/404.php';
                    // window.location.reload();
                }
            }
        }
    }, {
        key: 'getNextReservablePeriod',
        value: function getNextReservablePeriod(destCode, departure) {
            return this.winresCloudService.makeAuthenticatedRequest('GetNextReservablePeriod', {
                DestCode: destCode,
                IsDeparture: departure
            });
        }
    }, {
        key: 'setParamsToUrl',
        value: function setParamsToUrl(params, reload) {
            // console.trace('[urlService] setParamsToUrl called:', params, reload);

            var urlTemplate = wrc.urlTemplate;

            if (this.useQueryString) {
                var url = new URL(window.location);
                var qs = new URLSearchParams(url.search);
                qs.set('d1', params.bd);
                qs.set('d2', params.ed);
                if (params.na > 0 && params.na != 2) {
                    qs.set('na', params.na);
                } else {
                    qs.delete('na');
                }
                if (params.nc > 0) {
                    qs.set('nc', params.nc);
                } else {
                    qs.delete('nc');
                }
                if (params.ni > 0) {
                    qs.set('ni', params.ni);
                } else {
                    qs.delete('ni');
                }
                url.search = qs.toString();
                // console.log('[UrlService]', 'Replacing with:', url.href);
                var target = url.pathname + url.search + url.hash;
                this.$location.replace();
                this.$location.url(target); // Can't use replaceState here - Angular would override it immediately.
            } else if (urlTemplate) {
                var substitutions = [{
                    name: '[destinationNameFi]',
                    value: params.dn
                }, {
                    name: '[destinationCode]',
                    value: params.dc
                }, {
                    name: '[productCode]',
                    value: params.pc
                }, {
                    name: '[beginDateISO]',
                    value: params.bd
                }, {
                    name: '[endDateISO]',
                    value: params.ed
                }, {
                    name: '[numAdults]',
                    value: params.na || 2
                }, {
                    name: '[numChildren]',
                    value: params.nc || 0
                }, {
                    name: '[numInfants]',
                    value: params.ni || 0
                }, {
                    name: '[stopID]',
                    value: params.si
                }];

                var pathTemplate = urlTemplate.split('#!/')[1];

                _.each(substitutions, function (s) {
                    pathTemplate = pathTemplate.replace(s.name, s.value);
                });

                pathTemplate = pathTemplate.replace(/\/undefined/g, '');

                window.location.hash = '#!/' + pathTemplate;
            } else {
                var pp = [params.dn, params.dc, params.pc, params.bd, params.ed, params.na || 2, params.nc || 0, params.ni || 0].filter(function (p) {
                    return p != null;
                });

                if (params.d) {
                    // Add "departure" between destination name and destination code.
                    pp.splice(1, 0, 'departure');
                }

                window.location.hash = '#!/' + pp.join('/');
            }

            if (reload === true) {
                console.log('[urlService] Reload', window.location.href);
                window.location.reload();
            }
        }

        // Get url params from template
        // [destinationNameFi] -> dn
        // [destinationCode] -> dc
        // [productCode] -> pc
        // [beginDateISO] -> bd
        // [endDateISO] -> ed
        // [numAdults] -> na
        // [numChildren] -> nc
        // [numInfants] -> ni
        // [stopID] -> si

        //                     [destinationNameFi]/[destinationCode]/[productCode]/[beginDateISO]
        // wp-template/kohde/#!/destName/destCode/prodCode/2020-01-01
        // =
        // dn = destName
        // dc = destCode
        // pc = prodCode
        // bd = 2020-01-01

        //                     [destinationCode]/[productCode]
        // wp-template/kohde/#!/destName/destCode
        // =
        // dc = destName
        // pc = prodCode

    }, {
        key: 'readUrlParamsFromTemplate',
        value: function readUrlParamsFromTemplate(path) {
            var urlTemplate = wrc.urlTemplate;

            // [destinationNameFi]/[destinationCode]/[productCode]/[beginDateISO]/[endDateISO]/[numAdults]/[numChildren]/[numInfants]/[stopID]
            var pathTemplate = urlTemplate.split('#!/')[1];
            var pathTemplateParts = pathTemplate.split('/');

            var substitutions = [{
                key: 'dn',
                name: '[destinationNameFi]'
            }, {
                key: 'dc',
                name: '[destinationCode]'
            }, {
                key: 'pc',
                name: '[productCode]'
            }, {
                key: 'bd',
                name: '[beginDateISO]'
            }, {
                key: 'ed',
                name: '[endDateISO]'
            }, {
                key: 'na',
                name: '[numAdults]'
            }, {
                key: 'nc',
                name: '[numChildren]'
            }, {
                key: 'ni',
                name: '[numInfants]'
            }, {
                key: 'si',
                name: '[stopID]'
            }];

            var _loop = function _loop() {
                var s = substitutions[k];
                var j = _.findIndex(pathTemplateParts, function (p) {
                    return p === s.name;
                });
                s.idx = j;
            };

            for (var k in substitutions) {
                _loop();
            }

            var p = path.split('/');

            // path starts with /, remove empty string element at start
            p.shift();

            var params = {};

            for (var i in p) {
                var _s = substitutions.find(function (ss) {
                    return ss.idx === +i;
                });
                if (_s) {
                    params[_s.key] = p[i];
                }
            }

            return params;
        }
    }, {
        key: 'readUrlParamsFixed',
        value: function readUrlParamsFixed(path, hasDestName) {
            var p = path.split('/');

            // path starts with /, remove empty string element at start
            p.shift();

            // Ignore /departure/ and /lahto/ in p
            p = _.filter(p, function (pp) {
                return pp !== 'departure' && pp !== 'lahto';
            });

            if (!hasDestName) {
                // Add null element at start
                p.unshift(null);
            }

            switch (p.length) {
                case 2:
                    return {
                        dn: p[0],
                        dc: p[1]
                    };
                case 3:
                    return {
                        dn: p[0],
                        dc: p[1],
                        pc: p[2]
                    };
                case 7:
                    return {
                        dn: p[0],
                        dc: p[1],
                        bd: p[2],
                        ed: p[3],
                        na: p[4],
                        nc: p[5],
                        ni: p[6]
                    };
                case 8:
                    return {
                        dn: p[0], // destName
                        dc: p[1], // destCode
                        pc: p[2], // prodCode
                        bd: p[3], // beginDate
                        ed: p[4], // endDate
                        na: p[5], // numAdults
                        nc: p[6], // numChildren
                        ni: p[7] // numInfants

                        // Note: to read stopID, there must be prodCode,
                        // because param count matters.
                        // If we had to use link without prodCode
                        // stopID would become numInfants
                    };case 9:
                    return {
                        dn: p[0], // destName
                        dc: p[1], // destCode
                        pc: p[2], // prodCode
                        bd: p[3], // beginDate
                        ed: p[4], // endDate
                        na: p[5], // numAdults
                        nc: p[6], // numChildren
                        ni: p[7], // numInfants
                        si: p[8] // stopID
                    };
            }
        }
    }, {
        key: 'readUrlParamsFromQueryString',
        value: function readUrlParamsFromQueryString() {
            var url = new URL(window.location);
            var qs = url.searchParams;

            // console.log('[UrlService] QS is:', qs);

            var destCode = null;
            var prodCode = null;

            var path = url.pathname || '';
            var parts = path.split('/').map(function (part) {
                return part.trim();
            }).filter(function (part) {
                return part.length > 0;
            });
            var lastPart = parts.length >= 1 && parts[parts.length - 1];
            var secondToLastPart = parts.length >= 2 && parts[parts.length - 2];
            if (secondToLastPart === 'majoitus') {
                var slugParts = lastPart.split('-');
                if (slugParts.length >= 3) {
                    destCode = slugParts[slugParts.length - 2].toUpperCase();
                    prodCode = slugParts[slugParts.length - 1].toUpperCase();
                }
            }

            return {
                dn: null, // destination name
                dc: destCode, // destination code
                pc: prodCode, // product code
                bd: qs.get('d1') || null, // begin date
                ed: qs.get('d2') || null, // end date
                na: qs.get('na') || 2, // number of adults
                nc: qs.get('nc') || 0, // number of children
                ni: qs.get('ni') || 0, // number of infants
                si: null // stop ID
            };
        }
    }, {
        key: 'readUrlParams',
        value: function readUrlParams(hasDestName) {
            if (this.useQueryString) {
                // console.log('[UrlService]', 'Reading URL parameters from the query string.');
                return this.readUrlParamsFromQueryString();
            }

            var params = {};

            var path = this.$location.path();

            if (path !== '') {
                // UI-route does not read url params on init, so use trick below
                // TODO: Use ui route correctly to resolve this problem

                // Uncomment this in future
                // Get query string (?param1=1&param2=2)
                // = {"param1": "1", "param2": "2"}
                // p = this.$location.search();

                // Support url with trailing slash by removing last /
                if (path.endsWith('/')) {
                    path = path.substring(0, path.length - 1);
                }

                if (wrc.urlTemplate) {
                    // [destinationNameFi]/[destinationCode]/[beginDateISO]/[endDateISO]/[numAdults]/[numChildren]/[numInfants]/[stopID]
                    params = this.readUrlParamsFromTemplate(path);
                } else {
                    // param1/param2
                    // = {"dn": "param1", "dc": "param2"}
                    params = this.readUrlParamsFixed(path, hasDestName);
                }

                if (!params) {
                    params = {};
                }

                var p = path.split('/');
                var isDeparture = _.some(p, function (pp) {
                    return pp === 'departure' || pp === 'lahto';
                });

                params.d = isDeparture;
            }

            return params;
        }

        // UI route url params

    }, {
        key: 'setRouteParams',
        value: function setRouteParams(params) {
            this.routeParams = params;
        }
    }, {
        key: 'hasQueryString',
        value: function hasQueryString() {
            return this.$location.url().startsWith('/?');
        }
    }, {
        key: 'isKohdeSivu',
        value: function isKohdeSivu() {
            return this.$location.absUrl().indexOf('#!') > -1 && this.$location.absUrl().indexOf('#!/?') === -1 || // Querystring in url = is not kohdesivu.
            this.isFixedKohdeSivu === true; // winresDeparture fixed kohdesivu.
        }
    }, {
        key: 'getSeoLinks',
        value: function getSeoLinks() {
            var _this2 = this;

            var params = this.readUrlParams(true);

            var endpoint = params.d ? 'Winres/x/SeoLinks/Departure?' : 'Winres/x/SeoLinks?';

            if (params.dn) {
                endpoint += 'DestName=' + params.dn;
            }

            if (params.dc) {
                endpoint += '&DestCode=' + params.dc;
            }

            if (params.pc) {
                endpoint += '&ProdCode=' + params.pc;
            }

            if (params.bd) {
                endpoint += '&BeginDate=' + params.bd;
            }

            if (params.ed) {
                endpoint += '&EndDate=' + params.ed;
            }

            return this.$q(function (resolve) {
                _this2.winresCloudService.get(endpoint).then(function (result) {
                    resolve(result.data);
                });
            });
        }

        //////////////////////////////////
        // Url watcher
        //////////////////////////////////

    }, {
        key: 'addForcedClassifications',
        value: function addForcedClassifications(classifications) {
            this.forcedClassifications = classifications;
        }
    }, {
        key: 'getClassifcationsInUse',
        value: function getClassifcationsInUse(params) {
            var _this3 = this;

            var classifications = [];

            var _loop2 = function _loop2(i) {
                // From url.
                var dc = params['dc' + i] != null && !_.isArray(params['dc' + i]) ? params['dc' + i].split(',') : [];

                var forcedClassifications = _this3.forcedClassifications[i - 1];

                // Forced internet classifcations + dc.
                var combined = _.compact(_.union(_.concat(forcedClassifications, dc)));

                // Map int classes for remove buttons.
                classifications.push(_.map(combined, function (c) {
                    return {
                        'code': c,
                        'forced': _.includes(forcedClassifications, c), // Can't remove.
                        'level': i
                    };
                }));
            };

            for (var i = 1; i <= 5; i++) {
                _loop2(i);
            }

            return classifications;
        }

        // Watch url params and handle callbacks.

    }, {
        key: 'createUrlWatcher',
        value: function createUrlWatcher(fields) {
            var _this4 = this;

            // Watch changes in url.
            this.watchUrlParams(function (params) {
                if (params !== undefined) {
                    // Create field watcher.
                    if (_this4.fieldWatch === undefined) {
                        var watchFields = _.filter(fields, function (field) {
                            return field.watch === true;
                        });
                        var watchValues = _.map(watchFields, function (field) {
                            return field.value;
                        });

                        // Watch changes in fields.
                        _this4.fieldWatch = _this4.$rootScope.$watchGroup(watchValues, function () {
                            return _this4.changeUrlParams(fields);
                        });
                    }

                    if (!_this4.prevent) {
                        // Call url readers.
                        _.each(_this4.urlReaders, function (reader) {
                            reader(params);
                        });
                    }
                }
            });
        }
    }, {
        key: 'watchUrlParams',
        value: function watchUrlParams(callback) {
            var _this5 = this;

            this.$rootScope.$watch(function () {
                return _this5.routeParams;
            }, callback, true);
        }

        // Url reader functions.

    }, {
        key: 'addReader',
        value: function addReader(func) {
            this.urlReaders.push(func);
        }
    }, {
        key: 'changeUrlParams',
        value: function changeUrlParams(fields) {
            var _this6 = this;

            // Prevent url reader callback.
            this.prevent = true;

            this.$timeout(function () {
                return _this6.prevent = false;
            }, 100);

            _.each(fields, function (f) {
                if (f.type === 'date') {
                    _this6.changeUrlParamDate(f.name, f.value());
                } else {
                    _this6.changeUrlParam(f.name, f.value());
                }
            });
        }
    }, {
        key: 'changeUrlParam',
        value: function changeUrlParam(param, value) {
            if (value == null) {
                return;
            }

            if (_.isArray(value)) {
                if (value.length > 0) {
                    if (value.length > 1) {
                        this.$location.search('' + param, value.join(','));
                    } else {
                        this.$location.search('' + param, value);
                    }
                }
            } else {
                this.$location.search('' + param, value);
            }
        }
    }, {
        key: 'changeUrlParamDate',
        value: function changeUrlParamDate(param, value) {
            if (value != null) {
                this.$location.search('' + param, (0, _utils.formatISODate)(value));
            }
        }
    }, {
        key: 'removeUrlParam',
        value: function removeUrlParam(paramName, paramValue) {
            if (paramValue) {
                var changedParamValue = _.filter(this.routeParams[paramName].split(','), function (p) {
                    return p !== paramValue;
                });

                if (changedParamValue.length === 0) {
                    // Remove entire url param.
                    this.$location.search('' + paramName, null);
                } else {
                    // Remove a value from url param.
                    // paramValue="AK": dc1=MA,AK -> dc1=MA
                    this.$location.search('' + paramName, changedParamValue.join(','));
                }
            } else {
                // Remove entire url param.
                this.$location.search('' + paramName, null);
            }
        }
    }]);

    return UrlService;
}();

UrlService.$inject = ['$rootScope', '$location', 'winresCloudService', '$q', '$timeout'];


//////////////////
// WEBPACK FOOTER
// ./src/winresCloud/urlService.js
// module id = 578
// module chunks = 2